import React, { useEffect, useState } from "react";
import { resourceLimits } from "worker_threads";
import styles from "../dashboard/componentsStyle/regularparentpermit.module.css";
import { ReactComponent as LogoSvg } from '../svg/newlogo.svg';
import { Backdrop, CircularProgress, ToggleButton, ToggleButtonGroup } from '@mui/material';

const imageStyle: React.CSSProperties = {
    width: "100%",              // 화면 너비 꽉 채우기
    height: "auto",             // 가로·세로 비율 유지
    objectFit: "contain",       // 잘리지 않도록
    display: "block",           // 인라인 간격 제거
    margin: "0 auto",           // 좌우 중앙
    maxWidth: 600               // 태블릿·PC에서 너무 커지지 않게
  };

const CoachingReportViewer: React.FC<any> = (props) => {

    const [id, setId] = useState();
    const [loading, setLoading] = useState(false);
    const [src, setSrc] = useState<string | null>(null);


    useEffect(() => {

        setLoading(true);

        const meta = document.createElement("meta");
        meta.name = "viewport";
        meta.content = "width=device-width, initial-scale=1";
        document.getElementsByTagName("head")[0].appendChild(meta);


        const url = window.location.href;
        var query = url.split("?insertId=")[1];

        const id = query.split("&code=")[0];
        const code = query.split("&code=")[1];


        if (+code === (4321 * (+id)) ) {

            fetch(`https://peetsunbae.com/dashboard/mycoach/getcoachingreportimg?id=` + id, {
                method: "get",
                headers: { "content-type": "application/json" },
            }).then((response: any) => {
                response.json()
                    .then((result: any) => {
                        
                        setLoading(false);

                        if(result.message === "success"){

                            const imgSrc = result.data.src;
                            if(imgSrc){
                                setSrc(imgSrc); // 이미지 URL 설정
                            } else {
                                setSrc(null); // 이미지가 없을 경우 null 설정
                            }

                        }
                        
                    })
            })
        }

    }, []);

    return (
        <div className={styles.main}>

            {
                src
                ?
                (
                    <div>
                        <img src={src} alt="Coaching Report" style={imageStyle} />
                    </div>
                )
                :
                ""
            }


            <div className={styles.logoDiv}>
                <LogoSvg className={styles.newlogo} />
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default CoachingReportViewer;